import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-abd60e2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "align-items-center container d-flex flex-column" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Cursos", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_card_img = _resolveComponent("b-card-img")!
  const _component_b_card = _resolveComponent("b-card")!
  const _component_b_card_group = _resolveComponent("b-card-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_b_card_group, { class: "ml-0" }, {
      default: _withCtx(() => [
        _createVNode(_component_b_card, {
          title: "Cursos grupales",
          "img-top": "",
          tag: "article",
          style: {"max-width":"20rem"},
          class: "mb-2 card-body",
          "border-variant": "white",
          align: "center",
          "title-tag": "h3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_card_img, {
              alt: "Imagen cursos grupales",
              class: "card-body--image",
              src: "https://firebasestorage.googleapis.com/v0/b/qqqqqqqqqqqq-f57b0.appspot.com/o/grupo.webp?alt=media&token=fe25304f-effa-4d28-9ae4-57eba0b3b214"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_card, {
          title: "Curso individual",
          tag: "article",
          style: {"max-width":"20rem"},
          class: "mb-2 card-body",
          "border-variant": "white",
          align: "center",
          "title-tag": "h3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_card_img, {
              alt: "Imagen curso individual",
              class: "card-body--image",
              src: "https://firebasestorage.googleapis.com/v0/b/qqqqqqqqqqqq-f57b0.appspot.com/o/indiv.webp?alt=media&token=3b37f3a3-9e93-4d1c-9ca0-0d3f77bfcad6"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_card_group, { class: "mr-0" }, {
      default: _withCtx(() => [
        _createVNode(_component_b_card, {
          title: "Clubs",
          "img-top": "",
          tag: "article",
          style: {"max-width":"20rem"},
          class: "mb-2 card-body",
          "border-variant": "white",
          align: "center",
          "title-tag": "h3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_card_img, {
              alt: "Imagen clubs",
              class: "card-body--image",
              src: "https://firebasestorage.googleapis.com/v0/b/qqqqqqqqqqqq-f57b0.appspot.com/o/convers.webp?alt=media&token=4a0be0fd-1d8e-4800-9795-608fbd638b70"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}